(function() {
  'use strict';

  if (!customElements.get('multicolumn-icon')) {
    customElements.define(
      'multicolumn-icon',
      class MulticolumnIcon extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          pagination: '.multicolumn-icon__pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.sectionEl = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        this.sliderInstance = false;

        console.log('Multicolumn Icon connected:', {
          enableSliderMobile: this.enableSliderMobile,
          hasSliderWrapper: !!this.sliderWrapper,
          blocksCount: this.sliderWrapper ? this.sliderWrapper.querySelectorAll('.f-column').length : 0
        });

        if (!this.enableSliderMobile) {
          console.log('Slider disabled - enableSliderMobile is false');
          return;
        }

        // Wait for FoxTheme and DOM to be ready
        this.waitForFoxTheme(() => {
          this.paginationEl = this.querySelector(this.selectors.pagination) || this.sectionEl.querySelector(this.selectors.pagination);
          console.log('Pagination element found:', !!this.paginationEl);
          this.init();
        });
      }

      waitForFoxTheme(callback) {
        const checkReady = () => {
          if (window.FoxTheme && window.FoxTheme.Carousel) {
            // Also ensure DOM is ready
            setTimeout(() => {
              callback();
            }, 50);
          } else {
            // Wait for FoxTheme to be available
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds max wait
            const checkInterval = setInterval(() => {
              attempts++;
              if (window.FoxTheme && window.FoxTheme.Carousel) {
                clearInterval(checkInterval);
                setTimeout(() => {
                  callback();
                }, 50);
              } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                console.warn('FoxTheme.Carousel not available after waiting');
              }
            }, 100);
          }
        };
        
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', checkReady);
        } else {
          checkReady();
        }
      }

      init() {
        // Remove swipe-mobile classes that conflict with Swiper
        this.classList.remove('swipe-mobile', 'swipe-mobile--1-cols', 'swipe-mobile--2-cols', 'swipe-mobile--3-cols');
        if (this.sliderWrapper) {
          this.sliderWrapper.classList.remove('swipe-mobile__inner');
        }

        // Initialize slider on mobile only
        const mql = window.matchMedia('(max-width: 767.98px)');
        this.handleMediaChange = this.handleMediaChange.bind(this);
        mql.addEventListener('change', this.handleMediaChange);
        this.handleMediaChange(mql);
      }

      handleMediaChange(mql) {
        if (mql.matches) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') {
          console.log('Slider already initialized');
          return;
        }

        console.log('Initializing slider...');

        // Ensure FoxTheme is available
        if (!window.FoxTheme || !window.FoxTheme.Carousel) {
          console.warn('FoxTheme.Carousel not available');
          return;
        }

        // Re-query elements to ensure they exist
        if (!this.sliderWrapper) {
          this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        }

        // Also try querying by class name directly
        if (!this.sliderWrapper) {
          this.sliderWrapper = this.querySelector('.multicolumn__items');
        }

        // Try finding any div with f-grid class
        if (!this.sliderWrapper) {
          const allDivs = this.querySelectorAll('div');
          this.sliderWrapper = Array.from(allDivs).find(div => 
            div.classList.contains('f-grid') || div.classList.contains('multicolumn__items')
          );
        }

        if (!this.sliderWrapper) {
          console.warn('Slider wrapper not found');
          console.log('Looking for:', this.selectors.sliderWrapper);
          console.log('In element:', this);
          console.log('Element HTML:', this.innerHTML.substring(0, 200));
          console.log('Available children:', Array.from(this.children).map(c => ({
            tag: c.tagName,
            classes: c.className,
            id: c.id
          })));
          return;
        }

        console.log('Slider wrapper found:', this.sliderWrapper);

        // Find pagination element if not already found
        if (!this.paginationEl) {
          this.paginationEl = this.querySelector(this.selectors.pagination) || this.sectionEl.querySelector(this.selectors.pagination);
        }

        if (!this.paginationEl) {
          console.warn('Pagination element not found for multicolumn-icon slider');
          console.log('Looking for:', this.selectors.pagination);
          console.log('In element:', this);
          console.log('In section:', this.sectionEl);
          return;
        }

        const slideCount = this.sliderWrapper.querySelectorAll('.f-column').length;
        console.log('Slide count:', slideCount);
        
        if (slideCount === 0) {
          console.warn('No slides found');
          return;
        }

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 0;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: spaceBetween,
          pagination: {
            el: this.paginationEl,
            type: 'bullets',
            clickable: true,
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
        };

        // Remove conflicting classes
        this.classList.remove('swipe-mobile', 'swipe-mobile--1-cols', 'swipe-mobile--2-cols', 'swipe-mobile--3-cols');
        this.classList.add(this.classes.swiper);
        
        this.sliderWrapper.classList.remove(this.classes.grid, 'swipe-mobile__inner');
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        
        // Ensure child elements have swiper-slide class
        const slideItems = this.sliderWrapper.querySelectorAll('.f-column');
        slideItems.forEach(item => {
          if (!item.classList.contains('swiper-slide')) {
            item.classList.add('swiper-slide');
          }
        });

        try {
          console.log('Creating Carousel instance...');
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
          this.sliderInstance.init();
          console.log('Slider initialized successfully:', !!this.sliderInstance.slider);

          if (Shopify.designMode && typeof this.sliderInstance === 'object') {
            document.addEventListener('shopify:block:select', (e) => {
              if (e.detail.sectionId != this.sectionId) return;
              let { target } = e;
              const index = Number(target.dataset.index);

              if (this.sliderInstance && this.sliderInstance.slider) {
                this.sliderInstance.slider.slideTo(index);
              }
            });
          }
        } catch (error) {
          console.error('Error initializing multicolumn-icon slider:', error);
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        if (this.sliderWrapper) {
          this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
          this.sliderWrapper.classList.add(this.classes.grid);
          
          // Remove swiper-slide class from child elements
          const slideItems = this.sliderWrapper.querySelectorAll('.swiper-slide');
          slideItems.forEach(item => {
            item.classList.remove('swiper-slide');
          });
        }
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
    );
  }
})();

